import { Button, Callout, Classes, Dialog } from "@blueprintjs/core";
import type { FC } from "react";
import { useDispatch } from "react-redux";
import { showNotification } from "../../../store/toasterDuck";

interface ApiKeyCreatedDialogProps {
  isOpen: boolean;
  apiKey: string | null;
  onClose: () => void;
}

export const ApiKeyCreatedDialog: FC<ApiKeyCreatedDialogProps> = ({
  isOpen,
  apiKey,
  onClose,
}) => {
  const dispatch = useDispatch();

  const handleCopy = async () => {
    if (!apiKey) return;

    await navigator.clipboard.writeText(apiKey);
    dispatch(
      showNotification({
        message: "API key copied to clipboard",
        intent: "success",
      }),
    );
  };

  return (
    <Dialog
      canEscapeKeyClose
      canOutsideClickClose
      isOpen={isOpen}
      onClose={onClose}
      title="Your API key"
    >
      <div className="bp4-dialog-body">
        <div className="focusoc-form-shell flex flex-col gap-4">
          <Callout
            className="rounded-xl border border-amber-200 bg-amber-50"
            intent="warning"
          >
            This API key will only be shown once.
          </Callout>

          <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="text-xs font-semibold uppercase text-slate-500">
              Secret
            </div>
            <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
              <code className="min-w-0 flex-1 break-all rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-700">
                {apiKey}
              </code>

              <Button
                icon="clipboard"
                intent="primary"
                onClick={handleCopy}
                text="Copy"
              />
            </div>
          </section>
        </div>
      </div>

      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button intent="success" onClick={onClose}>
            Done
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
